import { render, staticRenderFns } from "./TheNewsCreate.vue?vue&type=template&id=03278b30&"
import script from "./TheNewsCreate.vue?vue&type=script&lang=js&"
export * from "./TheNewsCreate.vue?vue&type=script&lang=js&"
import style0 from "./TheNewsCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports